// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Prop65WarningIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
            <path
                fill="currentColor"
                d="M15.8207919,12.03125 L9.15516731,0.65625 C8.64485523,-0.21875 7.35704205,-0.21875 6.84329197,0.65625 L0.180792065,12.03125 C-0.332020072,12.9031248 0.306698533,14 1.33454248,14 L14.6657927,14 C15.689543,14 16.330167,12.90625 15.8207924,12.03125 L15.8207919,12.03125 Z M7.24891779,4.25 C7.24891779,3.8359375 7.58485529,3.5 7.99891779,3.5 C8.41298029,3.5 8.74891779,3.83749962 8.74891779,4.25 L8.74891779,8.25 C8.74891779,8.6640625 8.41298029,9 8.0270426,9 C7.64110491,9 7.24891779,8.66562462 7.24891779,8.25 L7.24891779,4.25 Z M7.99891779,12 C7.45641777,12 7.01641771,11.5600004 7.01641771,11.0174999 C7.01641771,10.4750004 7.45610544,10.0349998 7.99891779,10.0349998 C8.54173014,10.0349998 8.98141787,10.4749994 8.98141787,11.0174999 C8.9801676,11.5593748 8.5426676,12 7.99891779,12 Z"
                transform="translate(.001)"
            />
        </svg>
    );
};

export default React.memo(Prop65WarningIcon);
